import React from 'react'
import Box from '@material-ui/core/Box'
import Skeleton from '@material-ui/lab/Skeleton'
import StatCard from 'pages/pga-coach/coach-analytics/components/stat-card'
import useStyles from './styles'

const TILE_COUNT = 4

// Holds the delta line's space while a tile loads so the tile keeps its height.
export const DeltaSkeleton = () => (
  <Skeleton variant="text" width={112} height={18} />
)

// Page-level placeholder for the "Your business at a glance" card.
const BusinessAtAGlanceSkeleton = () => {
  const classes = useStyles()

  return (
    <Box className={classes.card} data-testid="business-at-a-glance-skeleton">
      <Box className={classes.cardHeader}>
        <Skeleton variant="text" width={190} height={21} />
        <Skeleton
          variant="rect"
          width={140}
          height={36}
          style={{ borderRadius: 18 }}
        />
      </Box>
      <Box className={classes.grid}>
        {Array.from({ length: TILE_COUNT }, (_, index) => (
          <Box key={index} className={classes.tile}>
            <StatCard
              label={<Skeleton variant="text" width={80} height={14} />}
              loading
            >
              <DeltaSkeleton />
            </StatCard>
          </Box>
        ))}
      </Box>
    </Box>
  )
}

export default BusinessAtAGlanceSkeleton
